<!-- `item.text` is part of the condition because a link with no label is not a link. A column whose
     `cellRendererSelector` can hand this same param array to `iconButtonsRenderer` carries icon-only
     entries meant for that renderer, and they would otherwise render as empty clickable anchors. -->
<span class="secondary__link-icon" [hidden]="actionButtons.length == 0">
    @for(item of actionButtons; track item; let i = $index){
    @if(!item.isHidden && item.text){
    <a (click)="onUserAction(item.userAction)" [ngClass]="item.class" class="secondary-link">
        {{item.text}}
        @if(item.showGreenTick){<img [src]="ICONS.CHECK_CIRCLE"/>}
    </a>
    }}
</span>